import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { stageClass } from "../lib/api";

export default function StageDefinitions() {
  const [defs, setDefs] = useState([]);

  useEffect(() => {
    api.get("/config/stage-definitions").then(r => setDefs(r.data.stages));
  }, []);

  return (
    <div className="p-8 max-w-6xl" data-testid="stage-definitions-page">
      <div className="mb-8">
        <div className="text-xs font-mono uppercase tracking-wider text-[#5C5E66] mb-1">Reference</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">Stage Definitions</h1>
        <p className="text-sm text-[#5C5E66] mt-2 max-w-2xl">Criteria and typical actions for each stage of the BD pipeline. Use this as a shared playbook to align the team on how prospects move through the funnel.</p>
      </div>

      <div className="bg-white border border-[#E2E2E5]" data-testid="stage-definitions-table">
        <div className="grid grid-cols-[250px_1.5fr_1.5fr] gap-0 border-b border-[#E2E2E5] bg-[#F0F0F2]">
          <div className="px-4 py-2.5 text-[10px] font-mono uppercase tracking-wider text-[#5C5E66]">Stage</div>
          <div className="px-4 py-2.5 text-[10px] font-mono uppercase tracking-wider text-[#5C5E66]">Criteria</div>
          <div className="px-4 py-2.5 text-[10px] font-mono uppercase tracking-wider text-[#5C5E66]">Typical Actions</div>
        </div>
        {defs.map((d, idx) => (
          <div key={d.stage} className="grid grid-cols-[250px_1.5fr_1.5fr] gap-0 border-b border-[#E2E2E5] last:border-0 row-hover" data-testid={`stage-def-${idx}`}>
            <div className="px-4 py-4 flex items-start gap-2">
              <span className="font-mono text-[10px] text-[#5C5E66] tabular-nums">{String(idx + 1).padStart(2, "0")}</span>
              <span className={`inline-block px-2 py-0.5 text-[11px] font-mono uppercase tracking-wider ${stageClass(d.stage)}`}>{d.stage}</span>
            </div>
            <div className="px-4 py-4 text-sm leading-relaxed">{d.criteria}</div>
            <div className="px-4 py-4 text-sm leading-relaxed text-[#5C5E66]">{d.typical_actions}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
